import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  openReviewForFile,
  selectedNewSites,
  selectedUpdatedSites,
  selectedDeletedSites,
  currentUploadStep,
} from '../../common/atom/atoms';
import { useSetAtom } from 'jotai';

export default function FileReviewUploadtopHeading() {
  const setOpen = useSetAtom(openReviewForFile);
  const setSelectedNewSites = useSetAtom(selectedNewSites);
  const setSelectedUpdatedSites = useSetAtom(selectedUpdatedSites);
  const setSelectedDeletedSites = useSetAtom(selectedDeletedSites);
  const setCurrentStep = useSetAtom(currentUploadStep);

  const handleClose = () => {
    // Clear all selections and reset state
    setSelectedNewSites({});
    setSelectedUpdatedSites({});
    setSelectedDeletedSites({});
    setCurrentStep(0);
    setOpen(false);
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography
        sx={{
          color: 'rgba(0, 0, 0, 0.80)',
          fontSize: 20,
          fontFamily: 'Poppins',
          fontWeight: 500,
          lineHeight: 1.2,
        }}
      >
        Upload
      </Typography>

      <IconButton size="small" onClick={handleClose}>
        <CloseIcon sx={{ color: '#192126' }} />
      </IconButton>
    </Box>
  );
}
